import { Card, CardContent, Typography, Box } from '@mui/material';

const cores = [
  { cor: 'green', texto: 'Latência Normal (≤ 0.5s)' },
  { cor: 'orange', texto: 'Latência Moderada (0.5s - 1s)' },
  { cor: 'orangered', texto: 'Latência Alta (1s - 2s)' },
  { cor: 'red', texto: 'Latência Crítica (> 2s ou Offline)' }
];

const LegendaLatencia = () => {
  return (
    <Card
      sx={{
        backgroundColor: '#2a2a2a',
        color: '#fff',
        margin: 2,
        minWidth: '660px', // 2 cards de 320px + margem entre
        maxWidth: 'calc(100% - 32px)', // evita quebra em telas pequenas
        paddingBottom: 1
      }}
      elevation={3}
    >
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Latência é o tempo que o sistema demora para responder.
        Quando a resposta é rápida, o serviço está funcionando bem.
        Se demora muito, pode indicar lentidão ou problema.
        </Typography>

        {cores.map((item, idx) => (
          <Box key={idx} sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
            <Box
              sx={{
                width: 16,
                height: 16,
                backgroundColor: item.cor,
                borderRadius: 1,
                marginRight: 1
              }}
            />
            <Typography variant="body2">{item.texto}</Typography>
          </Box>
        ))}
      </CardContent>
    </Card>
  );
};

export default LegendaLatencia;
